import styles from "./styles";
import "./styles.css"

export default function Banner({children}:{children?:any}){


    return(<div  >
     
    <div style={styles.banner}>
        <div className="container">

        {children}
        </div>
    </div>
    </div>
    )

}